var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumetnView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 38,
    viewBox: "0 0 52 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3126_7611)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 9C24.4087 9 22.8826 9.63214 21.7574 10.7574C20.6321 11.8826 20 13.4087 20 15C20 16.5913 20.6321 18.1174 21.7574 19.2426C22.8826 20.3679 24.4087 21 26 21C27.5913 21 29.1174 20.3679 30.2426 19.2426C31.3679 18.1174 32 16.5913 32 15C32 13.4087 31.3679 11.8826 30.2426 10.7574C29.1174 9.63214 27.5913 9 26 9ZM26 25C23.3478 25 20.8043 23.9464 18.9289 22.0711C17.0536 20.1957 16 17.6522 16 15C16 12.3478 17.0536 9.8043 18.9289 7.92893C20.8043 6.05357 23.3478 5 26 5C28.6522 5 31.1957 6.05357 33.0711 7.92893C34.9464 9.8043 36 12.3478 36 15C36 17.6522 34.9464 20.1957 33.0711 22.0711C31.1957 23.9464 28.6522 25 26 25ZM26 0C16 0 7.46 6.22 4 15C7.46 23.78 16 30 26 30C36 30 44.54 23.78 48 15C44.54 6.22 36 0 26 0Z",
    fill: "#363636"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3126_7611",
    x: 0,
    y: 0,
    width: 52,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3126_7611"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3126_7611",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumetnView);
export default __webpack_public_path__ + "static/media/documetnView.dfc973210b440e18dc6aae1f18b77af9.svg";
export { ForwardRef as ReactComponent };